import { cn } from '@/lib/utils';

export const chipClass = (active: boolean) =>
  cn(
    'rounded-full border px-3 py-1 text-xs transition-colors',
    active ? 'border-primary bg-primary text-primary-foreground' : 'border-border hover:bg-accent/60',
  );
